import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";
import { offsetLimitPagination } from "@apollo/client/utilities";
import config from "../config";

const httpLink = new HttpLink({ uri: config.RUNTIME_GQL_URL });

const authMiddleware = (authToken) =>
  new ApolloLink((operation, forward) => {
    if (authToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      });
    }

    return forward(operation);
  });

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        clinicalPipeline: offsetLimitPagination(["count", "offset"]),
      },
    },
  },
});

export const useAppApolloClient = () => {
  const authToken: string = sessionStorage.getItem("token-LciClinicalPipeline") || "";

  return new ApolloClient({
    link: authMiddleware(authToken).concat(httpLink),
    cache,
  });
};
